import Vue from 'vue'

export default async (page = 1) => {
  const res = await Vue.axios.get(`/billing/orders?page=${page}&status=pending`)
  return res.data
}



// WEBPACK FOOTER //
// ./src/services/billing/fetch-orders.js